import { createFileRoute } from "@tanstack/react-router";
import { SpringsLandingPage, buildSpringsLandingHead } from "@/components/SpringsLandingPage";
import { getSpringsLandingConfig } from "@/lib/springsLandingData";

const CONFIG = getSpringsLandingConfig("colorado-springs-locksmith-seo");

export const Route = createFileRoute("/colorado-springs-locksmith-seo")({
  head: () => buildSpringsLandingHead(CONFIG),
  component: () => <SpringsLandingPage config={CONFIG} />,
});
